module.exports = __webpack_public_path__ + "img/part_b_img@2x.87599a08.png";